# ---
# Утилиты для работы со временем
# Обертки над moment для удобочитаемости
# ---
dateAfter  = (date, point) -> moment(date).isAfter(point)
dateBefore = (date, point) -> moment(date).isBefore(point)

dateBetween = (date, interval_start, interval_end) ->
  lhs = if interval_start? then dateAfter(date, interval_start) else true
  rhs = if interval_end?   then dateBefore(date, interval_end)  else true
  lhs and rhs

dateAdd = (date, amount, granulation) ->
  moment(date).add(amount, granulation).toDate()

dateSubtract = (date, amount, granulation) ->
  moment(date).subtract(amount, granulation).toDate()


# ---
# Чекпоинты заказа и их приоритеты
# ---
CHECKPOINTS_META =
  isPastDeliveryEndDeadline:         { priority: 100, queue: 'status',       type: 'error' },
  isPastDeliveryStartDeadline:       { priority: 90,  queue: 'status',       type: 'error' },
  isPastCookingEndDeadline:          { priority: 80,  queue: 'status',       type: 'error' },
  isPastCookingStartDeadline:        { priority: 70,  queue: 'status',       type: 'error' },
  isPastConfirmDeadline:             { priority: 60,  queue: 'status',       type: 'error' },
  isJustCreated:                     { priority: 50,  queue: 'status',       type: 'info'  },
  isPastPaymentDeadline:             { priority: 100, queue: 'payment',      type: 'error' },
  isPastCourierDeadline:             { priority: 100, queue: 'courier',      type: 'error' },
  isPastRestaurantConfirmDeadline:   { priority: 100, queue: 'restaurant',   type: 'error' }



module.exports =
  # ---
  # Самые актуальные по приоритету чекпоинты заказа в каждой группе (очереди)
  # ---
  checkpoints: Em.computed Em.keys(CHECKPOINTS_META)..., ->
    queues = {}
    for checkpoint, meta of CHECKPOINTS_META
      cpValue = @get(checkpoint)
      continue unless cpValue

      queue = queues[meta.queue]
      if not queue or queue.priority < meta.priority
        queues[meta.queue] =
          checkpoint: checkpoint.underscore()
          priority:   meta.priority
          type:       meta.type

    v for k, v of queues

  problems:    Em.computed.filterBy('checkpoints', 'type', 'error')
  hasProblems: Em.computed.gt('problems.length', 0)

  # ---
  # Свойства, по которым строятся чекпоинты
  # ---
  isPastDeliveryEndDeadline: (->
    not (@get('status') in ['complete', 'undo'])\
    and dateAfter(@get('monitor.globalTime'), @get('deliveryEndDeadlineAt'))
  ).property(
    'status',
    'monitor.globalTime',
    'deliveryEndDeadlineAt')

  isPastDeliveryStartDeadline: (->
    return false if @get('takeaway')

    not (@get('status') in ['delivery', 'complete', 'undo'])\
    and dateAfter(@get('monitor.globalTime'), @get('deliveryStartDeadlineAt'))
  ).property(
    'status',
    'takeaway',
    'monitor.globalTime',
    'deliveryStartDeadlineAt')

  isPastCookingEndDeadline: (->
    not (@get('status') in ['prepared', 'delivery', 'complete', 'undo'])\
    and dateAfter(@get('monitor.globalTime'), @get('cookingEndDeadlineAt'))
  ).property(
    'status',
    'monitor.globalTime',
    'cookingEndDeadlineAt')

  isPastCookingStartDeadline: (->
    not (@get('status') in ['preparing', 'prepared', 'delivery', 'complete', 'undo'])\
    and dateAfter(@get('monitor.globalTime'), @get('cookingStartDeadlineAt'))
  ).property(
    'status',
    'monitor.globalTime',
    'cookingStartDeadlineAt')

  isPastConfirmDeadline: (->
    (@get('status') in ['pending'])\
    and dateAfter(@get('monitor.globalTime'), @get('confirmDeadlineAt'))
  ).property(
    'status',
    'monitor.globalTime',
    'confirmDeadlineAt')

  isPastPaymentDeadline: (->
    return false unless @get('isPaymentCard')
    payment = @get('payment')
    return false unless payment

    not (@get('status') in ['pending', 'complete', 'undo'])\
    and not payment.get('payment_success')\
    and dateBetween(@get('monitor.globalTime'), @get('paymentDeadlineAt'), @get('delivery_at'))
  ).property(
    'status',
    'isPaymentCard',
    'payment.payment_success',
    'paymentDeadlineAt',
    'monitor.globalTime'
    'delivery_at')

  isPastCourierDeadline: (->
    return false if @get('takeaway') || @get('hasActiveExternalDelivery')

    (@get('status') in ['preparing', 'prepared'])\
    and not @get('courier.id')\
    and dateBetween(@get('monitor.globalTime'), @get('courierDeadlineAt'), @get('delivery_at'))
  ).property(
    'status',
    'takeaway',
    'courier.id',
    'delivery_at',
    'courierDeadlineAt',
    'monitor.globalTime')

  isJustCreated: (->
    lowerBound = moment(@get('published_at'))
      .add(1, 'minutes')
      .toDate()

    (@get('status') in ['pending'])\
    and dateBetween(@get('monitor.globalTime'), lowerBound, @get('confirmDeadlineAt'))
  ).property(
    'status',
    'monitor.globalTime',
    'confirmDeadlineAt',
    'published_at')

  isPastRestaurantConfirmDeadline: (->
    uses_pos = @get('restaurant.uses_pos')

    # Временно отключить чекпоинт
    return false unless uses_pos

    deadline    = @get('restaurantConfirmDeadlineAt')
    confirmedAt = @get('restaurant_confirmed_at')

    return false unless deadline
    return false if confirmedAt

    (@get('status') in ['confirm'])\
    and dateBetween(@get('monitor.globalTime'), deadline, @get('delivery_at'))
  ).property(
    'restaurant.uses_pos'
    'status',
    'restaurant_confirmed_at',
    'restaurantConfirmDeadlineAt',
    'monitor.globalTime')

